var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, InputTextarea, Typography } from "@uigovpe/components";
import { useCallback, useEffect, useMemo, useState, } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { createContribution, getMyContributions, updateContribution, } from "../../../apis/contributions";
import { getConsultationById, } from "../../../apis/consultations";
import { getApiErrorMessage } from "../../../apis/http";
import { useAuth } from "../../auth/AuthContext";
import { ResponsesSummary } from "../components/ResponsesSummary";
import { buildAnswerMapFromContribution, findContributionBySource, sortConsultationItems, } from "../utils/participation";
var normalizeAnswerValue = function (value) {
    if (Array.isArray(value)) {
        return value.slice().sort().join("|");
    }
    return (value || "").trim();
};
var getTabFromSearchParams = function (searchParams) {
    return searchParams.get("tab") === "responses" ? "responses" : "questions";
};
var pageShellStyle = {
    display: "flex",
    justifyContent: "center",
    minHeight: "100%",
    padding: "32px 16px 48px",
};
var pageContainerStyle = {
    display: "grid",
    gap: 24,
    width: "100%",
    maxWidth: 960,
};
var titleCardStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    borderTop: "8px solid #0B4F8C",
    display: "grid",
    gap: 8,
    padding: 16,
};
var tabsBarStyle = {
    borderBottom: "1px solid #D1D5DB",
    display: "flex",
    gap: 4,
};
var tabButtonStyle = {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: 14,
    padding: "8px 16px",
    position: "relative",
};
var feedbackStyles = {
    error: { background: "#FFE4E4", color: "#7A1F1F" },
    info: { background: "#E6F3FF", color: "#0B4F8C" },
    success: { background: "#EAFBD7", color: "#245C15" },
    warning: { background: "#FFF7D6", color: "#7A5800" },
};
var feedbackBoxStyle = {
    borderRadius: 12,
    padding: "12px 16px",
};
var questionCardStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
    display: "grid",
    gap: 16,
    padding: 24,
};
var inputGroupStyle = {
    display: "grid",
    gap: 8,
};
var optionRowStyle = {
    alignItems: "center",
    display: "flex",
    gap: 8,
};
var FooterActions = function (_a) {
    var canSubmit = _a.canSubmit, existingContribution = _a.existingContribution, isDirty = _a.isDirty, onClear = _a.onClear, onSubmit = _a.onSubmit, submitting = _a.submitting;
    return (_jsxs("div", __assign({ style: {
            alignItems: "center",
            display: "flex",
            gap: 16,
            justifyContent: "space-between",
            marginTop: 8,
        } }, { children: [_jsx(Button, { label: "Limpar formul\u00E1rio", link: true, onClick: onClear, severity: "secondary" }), _jsx(Button, { disabled: submitting || (existingContribution ? !isDirty : false) || !canSubmit, label: submitting
                    ? "Enviando..."
                    : existingContribution
                        ? "Atualizar contribuição"
                        : "Enviar", onClick: onSubmit })] })));
};
var FeedbackBox = function (_a) {
    var message = _a.message, severity = _a.severity;
    return (_jsx("div", __assign({ style: __assign(__assign({}, feedbackBoxStyle), feedbackStyles[severity]) }, { children: _jsx(Typography, { children: message }) })));
};
var FormTabButton = function (_a) {
    var active = _a.active, label = _a.label, onClick = _a.onClick;
    return (_jsxs("button", __assign({ "aria-pressed": active, onClick: onClick, style: __assign(__assign({}, tabButtonStyle), { color: active ? "#1451B4" : "#6B7280", fontWeight: active ? 700 : 500 }), type: "button" }, { children: [label, active ? (_jsx("span", { style: {
                    background: "#1451B4",
                    borderRadius: 999,
                    bottom: -1,
                    height: 3,
                    left: 0,
                    position: "absolute",
                    right: 0,
                } })) : null] })));
};
export var ConsultationFormPage = function () {
    var id = useParams().id;
    var consultationId = Number(id);
    var hasValidConsultationId = Number.isFinite(consultationId) && consultationId > 0;
    var navigate = useNavigate();
    var _a = useAuth(), accessToken = _a.accessToken, isAuthenticated = _a.isAuthenticated, isLoadingAuth = _a.isLoadingAuth, hasToken = _a.hasToken, profileError = _a.profileError, role = _a.role;
    var _b = useState(null), activeFeedback = _b[0], setActiveFeedback = _b[1];
    var _c = useState({}), answers = _c[0], setAnswers = _c[1];
    var _d = useState(null), consultation = _d[0], setConsultation = _d[1];
    var _e = useState(null), existingContribution = _e[0], setExistingContribution = _e[1];
    var _f = useState({}), initialAnswers = _f[0], setInitialAnswers = _f[1];
    var _g = useState(true), loading = _g[0], setLoading = _g[1];
    var _h = useState(null), pageError = _h[0], setPageError = _h[1];
    var _j = useSearchParams(), searchParams = _j[0], setSearchParams = _j[1];
    var _k = useState(function () {
        return getTabFromSearchParams(searchParams);
    }), selectedTab = _k[0], setSelectedTab = _k[1];
    var _l = useState(false), submitting = _l[0], setSubmitting = _l[1];
    var items = useMemo(function () { return sortConsultationItems(consultation === null || consultation === void 0 ? void 0 : consultation.consultationItems); }, [consultation === null || consultation === void 0 ? void 0 : consultation.consultationItems]);
    var isCitizen = role === "citizen";
    var isPrivileged = role === "agency_manager" || role === "admin_scge";
    var canSeeQuestionsTab = !isPrivileged;
    var canSubmitAnswers = isAuthenticated &&
        isCitizen &&
        (consultation === null || consultation === void 0 ? void 0 : consultation.type) === "with_form" &&
        consultation.status === "active";
    var isDirty = useMemo(function () {
        return items.some(function (item) {
            return normalizeAnswerValue(answers[item.id]) !==
                normalizeAnswerValue(initialAnswers[item.id]);
        });
    }, [answers, initialAnswers, items]);
    var syncExistingContribution = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, contribution, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accessToken || !hasValidConsultationId) {
                        setExistingContribution(null);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getMyContributions(accessToken)];
                case 2:
                    response = _a.sent();
                    contribution = findContributionBySource(response.data.contributions || [], consultationId, "form") || null;
                    setExistingContribution(contribution);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setExistingContribution(null);
                    setActiveFeedback({
                        message: getApiErrorMessage(error_1),
                        severity: "warning",
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [accessToken, consultationId, hasValidConsultationId]);
    useEffect(function () {
        setSelectedTab(getTabFromSearchParams(searchParams));
    }, [searchParams]);
    useEffect(function () {
        if (!canSeeQuestionsTab && selectedTab === "questions") {
            setSelectedTab("responses");
            setSearchParams({ tab: "responses" });
        }
    }, [canSeeQuestionsTab, selectedTab, setSearchParams]);
    useEffect(function () {
        if (!hasValidConsultationId) {
            setPageError("Consulta inválida.");
            setLoading(false);
            return;
        }
        var isMounted = true;
        var loadConsultation = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        setPageError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getConsultationById(consultationId, accessToken)];
                    case 2:
                        response = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setConsultation(response.data.consultation);
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setPageError(getApiErrorMessage(error_2));
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void loadConsultation();
        return function () {
            isMounted = false;
        };
    }, [accessToken, consultationId, hasValidConsultationId]);
    useEffect(function () {
        void syncExistingContribution();
    }, [syncExistingContribution]);
    useEffect(function () {
        var nextAnswers = buildAnswerMapFromContribution(items, existingContribution);
        setAnswers(nextAnswers);
        setInitialAnswers(nextAnswers);
    }, [existingContribution, items]);
    var handleInputChange = function (itemId, value) {
        setAnswers(function (currentAnswers) {
            var _a;
            return (__assign(__assign({}, currentAnswers), (_a = {}, _a[itemId] = value, _a)));
        });
    };
    var handleSelectMultipleChange = function (itemId, optionValue, checked) {
        setAnswers(function (currentAnswers) {
            var _a;
            var currentValue = Array.isArray(currentAnswers[itemId])
                ? __spreadArray([], currentAnswers[itemId], true) : [];
            return __assign(__assign({}, currentAnswers), (_a = {}, _a[itemId] = checked
                ? __spreadArray(__spreadArray([], currentValue, true), [optionValue], false) : currentValue.filter(function (value) { return value !== optionValue; }), _a));
        });
    };
    var validateRequiredAnswers = function () {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (!item.isRequired) {
                continue;
            }
            var answer = answers[item.id];
            if (item.type === "text" || item.type === "select_unique") {
                if (!answer || !String(answer).trim()) {
                    return "Responda a pergunta obrigat\u00F3ria: \"".concat(item.description, "\"");
                }
            }
            if (item.type === "select_multiple") {
                if (!Array.isArray(answer) || answer.length === 0) {
                    return "Selecione ao menos uma op\u00E7\u00E3o em \"".concat(item.description, "\"");
                }
            }
        }
        return null;
    };
    var buildPayload = function () { return ({
        answers: items.map(function (item) {
            var answer = answers[item.id];
            if (item.type === "text") {
                return {
                    consultationItemId: item.id,
                    value: String(answer || ""),
                };
            }
            if (item.type === "select_unique") {
                return {
                    consultationItemId: item.id,
                    jsonValue: answer ? [String(answer)] : [],
                };
            }
            return {
                consultationItemId: item.id,
                jsonValue: Array.isArray(answer) ? answer : [],
            };
        }),
    }); };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var validationError, payload, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    validationError = validateRequiredAnswers();
                    if (validationError) {
                        setActiveFeedback({
                            message: validationError,
                            severity: "error",
                        });
                        return [2 /*return*/];
                    }
                    setSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    payload = buildPayload();
                    if (!existingContribution) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateContribution(consultation.id, existingContribution.contribution.id, payload, accessToken)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createContribution(consultation.id, payload, accessToken)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [4 /*yield*/, syncExistingContribution()];
                case 6:
                    _a.sent();
                    setInitialAnswers(answers);
                    setActiveFeedback({
                        message: existingContribution
                            ? "Contribuição atualizada com sucesso."
                            : "Contribuição enviada com sucesso.",
                        severity: "success",
                    });
                    setSearchParams({ tab: "responses" });
                    return [3 /*break*/, 9];
                case 7:
                    error_3 = _a.sent();
                    setActiveFeedback({
                        message: getApiErrorMessage(error_3),
                        severity: "error",
                    });
                    return [3 /*break*/, 9];
                case 8:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var handleClear = function () {
        setAnswers({});
        setActiveFeedback(null);
    };
    var handleTabChange = function (nextTab) {
        setSelectedTab(nextTab);
        setSearchParams(nextTab === "responses" ? { tab: "responses" } : {});
    };
    return (_jsx("div", __assign({ style: pageShellStyle }, { children: _jsxs("div", __assign({ style: pageContainerStyle }, { children: [_jsx("div", { children: _jsx(Button, { label: "Voltar para a consulta", onClick: function () {
                            return navigate(consultation
                                ? "/details/".concat(consultation.id)
                                : "/details/".concat(consultationId));
                        }, severity: "secondary" }) }), activeFeedback ? _jsx(FeedbackBox, __assign({}, activeFeedback)) : null, loading ? (_jsx(Typography, { children: "Carregando..." })) : pageError || !consultation ? (_jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(FeedbackBox, { message: pageError || "Consulta não encontrada.", severity: "error" }), _jsx("div", { children: _jsx(Button, { label: "Voltar para consultas", onClick: function () { return navigate("/"); } }) })] }))) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: titleCardStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "lg" }, { children: consultation.title })), consultation.description ? (_jsx(Typography, { children: consultation.description })) : null] })), _jsxs("div", __assign({ style: tabsBarStyle }, { children: [canSeeQuestionsTab ? (_jsx(FormTabButton, { active: selectedTab === "questions", label: "Quest\u00F5es", onClick: function () { return handleTabChange("questions"); } })) : null, _jsx(FormTabButton, { active: selectedTab === "responses", label: "Respostas", onClick: function () { return handleTabChange("responses"); } })] })), selectedTab === "responses" ? (_jsx(ResponsesSummary, { accessToken: accessToken, items: items })) : (_jsxs("div", __assign({ style: { display: "grid", gap: 24 } }, { children: [consultation.type !== "with_form" ? (_jsx(FeedbackBox, { message: "Esta consulta n\u00E3o utiliza formul\u00E1rio. Use o fluxo de contribui\u00E7\u00E3o aberta.", severity: "warning" })) : null, !isLoadingAuth && !hasToken ? (_jsx(FeedbackBox, { message: "Fa\u00E7a login pelo Smartpass para responder a consulta.", severity: "info" })) : null, !isLoadingAuth && hasToken && profileError ? (_jsx(FeedbackBox, { message: "N\u00E3o foi poss\u00EDvel carregar seu perfil. Tente recarregar a p\u00E1gina.", severity: "error" })) : null, isAuthenticated && !isCitizen ? (_jsx(FeedbackBox, { message: "Apenas perfis citizen podem enviar respostas para esta consulta.", severity: "info" })) : null, consultation.status !== "active" ? (_jsx(FeedbackBox, { message: "Esta consulta n\u00E3o est\u00E1 mais recebendo novas respostas.", severity: "warning" })) : null, items.length === 0 ? (_jsx("div", __assign({ style: questionCardStyle }, { children: _jsx(Typography, { children: "Nenhuma pergunta cadastrada para esta consulta." }) }))) : (_jsxs(_Fragment, { children: [items.map(function (item) { return (_jsxs("div", __assign({ style: questionCardStyle }, { children: [_jsxs(Typography, __assign({ fontWeight: "medium" }, { children: [item.order, ". ", item.description, item.isRequired ? (_jsx("span", __assign({ style: { color: "#DC2626" } }, { children: " *" }))) : null] })), item.type === "text" ? (_jsx(InputTextarea, { disabled: !canSubmitAnswers, onChange: function (event) {
                                                        return handleInputChange(item.id, event.target.value);
                                                    }, placeholder: "Digite sua resposta aqui...", rows: 4, value: String(answers[item.id] || "") })) : item.type === "select_unique" ? (_jsx("div", __assign({ style: inputGroupStyle }, { children: (item.consultationItemOptions || []).map(function (option) { return (_jsxs("label", __assign({ style: optionRowStyle }, { children: [_jsx("input", { checked: answers[item.id] === option.value, disabled: !canSubmitAnswers, name: "item-".concat(item.id), onChange: function (event) {
                                                                    return handleInputChange(item.id, event.target.value);
                                                                }, type: "radio", value: option.value }), _jsx("span", { children: option.label })] }), option.id)); }) }))) : (_jsx("div", __assign({ style: inputGroupStyle }, { children: (item.consultationItemOptions || []).map(function (option) {
                                                        var currentValues = Array.isArray(answers[item.id])
                                                            ? answers[item.id]
                                                            : [];
                                                        return (_jsxs("label", __assign({ style: optionRowStyle }, { children: [_jsx("input", { checked: currentValues.includes(option.value), disabled: !canSubmitAnswers, onChange: function (event) {
                                                                        return handleSelectMultipleChange(item.id, option.value, event.target.checked);
                                                                    }, type: "checkbox" }), _jsx("span", { children: option.label })] }), option.id));
                                                    }) })))] }), item.id)); }), consultation.type === "with_form" ? (_jsxs("div", __assign({ style: { display: "grid", gap: 12 } }, { children: [existingContribution && !isDirty ? (_jsx(Typography, __assign({ size: "sm", style: { color: "#6B7280" } }, { children: "Nenhuma altera\u00E7\u00E3o pendente para salvar." }))) : null, _jsx(FooterActions, { canSubmit: Boolean(canSubmitAnswers), existingContribution: existingContribution, isDirty: isDirty, onClear: handleClear, onSubmit: handleSubmit, submitting: submitting })] }))) : null] }))] })))] }))] })) })));
};
